<zbp-zbchart-report-table
  reportLabel="Class Spread Report Table"
  [showProgressReportsHelp]="true"
  [leftHeaderText]="'Students'"
  [rightHeaderText]="'Test Scores and Status'"
  [zbChart]="zbChart"
  [printableReportHeadings]="printableReportHeadings"
  [isPrinting]="isPrinting"
/>
